import { useCallback, useRef } from 'react'

export const useSwimlaneScrollAdjustment = () => {
  const rowRefs = useRef<Record<string, HTMLDivElement | null>>({})
  const scrollContainerRef = useRef<HTMLDivElement | null>(null)

  const registerRowRef = useCallback(
    (id: string, ref: HTMLDivElement | null) => {
      rowRefs.current[id] = ref
    },
    []
  )

  const setScrollContainerRef = useCallback((ref: HTMLDivElement | null) => {
    scrollContainerRef.current = ref
  }, [])

  /**
   * スイムレーン折り畳み時にスクロール調整が必要か判定し、必要なら調整
   * @param id - スイムレーンID
   * @param isCurrentlyCollapsed - 現在折り畳まれているか
   */
  const handleCollapseWithScrollAdjust = useCallback(
    (id: string, isCurrentlyCollapsed: boolean): void => {
      // 開く操作の場合は何もしない
      if (isCurrentlyCollapsed) return

      const rowElement = rowRefs.current[id]
      const scrollContainer = scrollContainerRef.current
      if (!rowElement || !scrollContainer) return

      const rowTop = rowElement.offsetTop
      const scrollTop = scrollContainer.scrollTop
      const isStickyActive = rowTop < scrollTop

      if (isStickyActive) {
        // 折り畳み後、次フレームでスクロール調整
        requestAnimationFrame(() => {
          scrollContainer.scrollTop = rowTop
        })
      }
    },
    []
  )

  return {
    registerRowRef,
    setScrollContainerRef,
    handleCollapseWithScrollAdjust,
  }
}
